// extracted by mini-css-extract-plugin
export var menu = "Tabs-module--menu--1lxpk";
export var aactive = "Tabs-module--aactive--QeSee";
export var content = "Tabs-module--content--wsGmA";
export var active = "Tabs-module--active--1Cjqf";
export var spinAround = "Tabs-module--spinAround--GgqIZ";